import { AvvirRoutingEvent } from "type_aliases";

export type ToMetricsPageEvent = AvvirRoutingEvent<typeof TO_METRICS_PAGE__DEPRECATED, { projectId: string }>

export const TO_METRICS_PAGE__DEPRECATED = "to_metrics_page";
